
import Clarity from "@microsoft/clarity";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from "../../../project_config";
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import CatalogEmptyState from "../../common/catalog/CatalogEmptyState";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import Loading from "../../common/loading/Loading";
import ActionSection from "./action/ActionSection";
import InfoSection from "./info/InfoSection";
import StateSection from "./state/StateSection";

export default function PaymentDetail() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop] = useState(window.innerWidth > 768);
	const navigate = useNavigate();
	const params = useParams();
	const paymentId = params.paymentId;
	const linkDataList = [
		{ label: "خانه", href: "/" },
		{ label: "پرداخت‌ها", href: "/payment_list/" },
		{ label: "جزئیات", href: `/payment_detail/${paymentId}/` },
	];
	const [payment, setPayment] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchPayment();
	}, [paymentId]);

	function fetchPayment() {
		setIsLoading(true);
		setErrorMessage("");
		api
			.paymentDetail({
				token: LoginHelper.getToken(),
				payment_id: paymentId,
			})
			.then((result) => {
				setPayment(result);
				setIsLoading(false);
			})
			.catch((err) => {
				setIsLoading(false);
				setPayment(null);
				if (err?.data?.message) {
					setErrorMessage(err.data.message);
				} else {
					setErrorMessage("دریافت جزئیات پرداخت ناموفق بود.");
				}
			});
	}

	return (
		<>
			<Helmet>
				<title>جزئیات پرداخت | همراهتیم</title>
				<meta name="description" content="جزئیات پرداخت همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? "w-[1200px]" : ""} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div
						className={`${isDesktop ? "max-w-[720px]" : "px-[10px]"} mx-auto flex flex-col gap-5 pt-6 md:pt-8 pb-8`}
					>
						<section
							className="relative overflow-hidden rounded-[16px] border border-darkBlue/10 bg-gradient-to-br from-white via-lightCta/80 to-white shadow-[0_10px_28px_rgba(39,106,166,0.1)]"
							aria-label="رسید پرداخت"
						>
							<div
								className="h-[3px] w-full bg-gradient-to-l from-cta via-[#FF8A6B] to-darkBlue"
								aria-hidden
							/>
							<div className="px-5 py-5 md:py-6 text-center">
								<h1 className="font-Vazir-600 text-[17px] md:text-[18px] text-darkBlue">
									رسید پرداخت
								</h1>
							</div>
						</section>

						{isLoading && (
							<div className="flex justify-center py-12">
								<Loading color="#ff694b" width={44} />
							</div>
						)}

						{!isLoading && (errorMessage || !payment) && (
							<CatalogEmptyState
								message={
									errorMessage || "رسید پرداخت پیدا نشد."
								}
								hint="ممکن است لینک منقضی شده باشد یا به این تراکنش دسترسی نداشته باشید."
								actionLabel="بازگشت به فهرست پرداخت‌ها"
								onAction={() => navigate("/payment_list/")}
							/>
						)}

						{!isLoading && payment && (
							<>
								<InfoSection payment={payment} />
								<StateSection payment={payment} />
								<ActionSection payment={payment} />
							</>
						)}
					</div>
				</div>
				<div>
					<Footer isDesktop={isDesktop} />
				</div>
			</div>
		</>
	);
}
